import '../styles/index.css'

import $ from 'jquery';

const _dir = $('html').attr('dir');

import './plugins/formValidation/formValidation';
import './plugins/formValidation/formValidation.css';

((
    ($) => {

        let _options = {
            checkRequired: true,
            scrollToFirstError: true,
            showErrorGeneralMsg: false,
            requiredMsg: application.translations.required_field,
        };
        $('.js-validate').validateForm(_options);

    }
)(jQuery));
